<template>
  <a :href="siteUrl('/')" aria-label="پی‌جیب - صفحه اصلی" class="flex items-center gap-2.5 cursor-pointer">
    <!-- <span
      class="grid h-9 w-9 place-items-center rounded-[10px] bg-primary text-primary-foreground text-lg font-black">P</span>
    <span class="text-lg font-extrabold tracking-tight">PayJib</span> -->
    <img src="/svg/logo.svg" alt="لوگوی پی‌جیب" />
  </a>
</template>

<script setup lang="ts">
const siteUrl = useSiteUrl()
</script>
